module.exports = __webpack_public_path__ + "static/media/escolhaMultiplaOutro.25d0397a.jpg";